import {
  CombinedQualification,
  SelectedQuota,
} from '../../shared/interfaces/qualification.interface';

export class QuotaFlagsComputer {
  constructor(
    private readonly _quotas: SelectedQuota[],
    private _qualification: Pick<
      CombinedQualification,
      'hasNestedQuotas' | 'census'
    >
  ) {}

  public add(): boolean {
    return !this._quotas?.length && !this._qualification.hasNestedQuotas;
  }

  public edit(): boolean {
    return !!this._quotas?.length && !this._qualification.hasNestedQuotas;
  }

  public delete(): boolean {
    return !!(this._quotas?.length || this._qualification.hasNestedQuotas);
  }

  public census(): boolean {
    return !!(
      this._qualification.census?.enabled &&
      !!this._qualification.census?.data?.length &&
      !this._qualification.hasNestedQuotas
    );
  }
}
